<template>
  <ion-page class="review">
    <img class="review_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between" style="height: 4rem">
        <div class="nav-icon"></div>
        <span>复习</span>
        <div style="display: inline-flex; align-items: center">
          <switch-font-size />
          <img
            class="nav-icon"
            :src="getBrandImageUrl('close_icon.png')"
            alt=""
            @click="onCloseSelf"
          />
        </div>
      </div>
    </ion-header>
    <div class="review_outside">
      <div class="statistic">{{ totalNum }}个单词</div>
      <div class="review_page" @scroll="scrollEvent">
        <div class="word-list">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="word-list_item flex-row justify-between align-center cursor-pointer"
            :class="{ 'choose-true': item.selected === 2, 'choose-false': item.selected === 1 }"
            @click="onShowParaphrase(index, item, $event)"
          >
            <div class="flex-row flex-wrap ion-align-items-baseline">
              <span class="word-style flex-row align-center">
                <span class="word-style gray-color" style="flex-shrink: 0; font-size: 1rem"
                  >{{ index + 1 }}.</span
                >
                <span class="weight-600 switch-font-size">{{ item.word }}</span>
              </span>
              <span
                v-show="item.showParaphrase == 2"
                class="cnword word-style gray-color translate-middle"
                >{{ item.paraphrase }}</span
              >
            </div>

            <div class="choose-icon flex-row align-center">
              <img
                v-if="item.selected === 0 || item.selected === 2"
                class="test-icon"
                src="@/assets/teacher_index/version5/word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.selected === 1"
                class="test-icon"
                src="@/assets/teacher_index/version5/checked_word_false.svg"
                alt=""
                @click.stop="onClickYes(item, $event)"
              />
              <img
                v-if="item.selected === 0 || item.selected === 1"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/word_ok.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <img
                v-if="item.selected === 2"
                class="test-icon ml-3"
                src="@/assets/teacher_index/version5/checked_word_true.svg"
                alt=""
                @click.stop="onClickNot(item, $event)"
              />
              <img
                class="test-icon ml-3"
                :src="getBrandImageUrl('speed/not_play_icon.png')"
                alt=""
              />
              <img
                v-if="false"
                class="test-icon ml-3"
                :src="getBrandImageUrl('speed/playing_icon.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <page-white-background title="复习" router-type="modal" @router-back="onCloseSelf">
      <template #default>
        <div class="review_page">
          <div class="statistic mb-5">{{ dataList.length }}个单词</div>
          <div class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between"
              @click="onShowParaphrase(index, item, $event)"
            >
              <span class="word-style flex-row align-center">
                <span class="word-style gray-color">{{ index + 1 }}.</span>{{ item.word }}
              </span>
              <span
                v-show="item.showParaphrase == 2"
                class="cnword word-style gray-color translate-middle"
                >{{ item.paraphrase }}</span
              >
              <div class="flex-row align-center">
                <img
                  v-if="item.selected === 0 || item.selected === 2"
                  class="test-icon"
                  :src="getBrandImageUrl('speed/not_check_icon.png')"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 1"
                  class="test-icon"
                  :src="getBrandImageUrl('speed/checked_icon.png')"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 0 || item.selected === 1"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/not_know_icon.png')"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  v-if="item.selected === 2"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/checked_not_know_icon.png')"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/not_play_icon.png')"
                  alt=""
                />
                <img
                  v-if="false"
                  class="test-icon ml-3"
                  :src="getBrandImageUrl('speed/playing_icon.png')"
                  alt=""
                />
              </div>
            </div>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
          </div>
        </div>
      </template>
    </page-white-background>-->
    <div class="review_bottom">
      <div class="review_bottom-content flex-row justify-between align-center">
        <div>
          <span
            >正确<span class="common-color">{{ yesNum }}</span></span
          >
          <span class="display-inline-block ml-1"
            >错误<span class="common-red-color">{{ notNum }}</span></span
          >
        </div>
        <div>
          <ion-button v-if="dataList.length" class="button-outline" shape="round" @click="autoPlay"
            >{{ autoPlayButtonText }}
          </ion-button>
          <ion-button class="golden_bg" shape="round" @click="doCheckAll">全选</ion-button>
          <ion-button class="green_bg" shape="round" @click="doSubmit">提交</ion-button>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { IonButton, IonHeader, IonPage, modalController } from "@ionic/vue"

import { checkmarkCircle, closeCircle, library } from "ionicons/icons"
import Sign from "@/views/speed/Sign"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"
import { getBrandImageUrl } from "@/js/brandImages"
import checkOkWord from "@/assets/teacher_index/version5/checked_word_false.svg"
import checkFalseWord from "@/assets/teacher_index/version5/checked_word_true.svg"
import SwitchFontSize from "@/views/other/SwitchFontSize.vue"

export default {
  name: "SpeedReview",
  components: {
    SwitchFontSize,
    IonHeader,
    PageWhiteBackground,
    IonPage,
    IonButton,
  },
  props: ["studentId", "mastery"],

  setup() {
    return {
      closeCircle,
      checkmarkCircle,
      library,
    }
  },

  data() {
    return {
      isDisabled: false,
      dataList: [],
      currentPage: 1,
      pageSize: 50,
      totalNum: 0,
      loading: false,
      yesNum: 0,
      notNum: 0,
      courseId: undefined,
      courseName: undefined,
      autoPlaySwitch: false,
      autoPlayTimer: undefined,
      autoTimePlayTimer: undefined,
      autoPlayIndex: 0,
      autoPlayButtonText: "播放",
      btnloading: false,
    }
  },

  mounted() {
    this.userinfo = this.store.getUser()
    this.queryMyWords()
    // this.alert('认识的词点 <b>✓</b>,<br>不熟悉的点 <b>×</b>。');
    this.alert(
      `<div style="line-height: 30px;">认识的词选 <img class="vertical-middle" style="width: 20px;" src="${checkOkWord}" />，\n不熟悉的选 <img class="vertical-middle" style="width: 20px;"src="${checkFalseWord}" />。</div>`,
      "",
      "",
      true
    )
  },

  methods: {
    getBrandImageUrl,
    routerBack() {
      modalController.dismiss()
    },
    //学新
    async openSign() {
      const modal = await modalController.create({
        component: Sign,
        componentProps: { studentId: this.studentId, step: 1 },
        cssClass: "modal_controller_class",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data) {
        await modalController.dismiss({ ...data })

        // if (data.hasOwnProperty('courseTypeId') && data.courseTypeId===16) {
        // } else {
        //   await modalController.dismiss();
        // }
      }
    },

    onShowParaphrase(index, item) {
      this.playSound(item.word)
      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          if (this.dataList[i].showParaphrase < 2) {
            this.dataList[i].showParaphrase++
          } else {
            this.dataList[i].showParaphrase = 0
          }
        }
      }
    },

    countSelectNum() {
      this.yesNum = 0
      this.notNum = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 1) {
          this.yesNum++
        } else if (this.dataList[i].selected == 2) {
          this.notNum++
        }
      }
    },

    //全选
    doCheckAll() {
      this.yesNum = 0
      this.notNum = 0
      const unSelectedArr = this.dataList.filter((i) => i["selected"] !== 2) // 所有未选中单词数组
      const unSelectedLen = unSelectedArr.length // 所有未选中单词数组长度
      this.notNum = this.dataList.length - unSelectedLen // 所有已选中单词数组长度
      for (let i = 0; i < unSelectedArr.length; i++) {
        const obj = unSelectedArr[i]
        if (this.notNum < 45) {
          // 当前未选中单词数组长度 < 45个单词内不认识的未选中单词
          if (obj["selected"] === 0) {
            this.notNum++
            this.tools.onClickNot(unSelectedArr[i])
          }
        } else {
          if (obj["selected"] !== 1) {
            // 如果选中效果为已学会，则不取消选中
            this.tools.onClickNull(unSelectedArr[i])
          }
        }
      }
      const arr = this.dataList.filter((i) => i["selected"] === 1)
      if (arr) {
        this.yesNum = arr.length
      }
    },

    //自动播放
    autoPlay() {
      clearInterval(this.autoPlayTimer)
      clearTimeout(this.autoTimePlayTimer)
      if (this.autoPlaySwitch) {
        this.autoPlaySwitch = false
        this.autoPlayButtonText = "播放"
      } else {
        this.autoPlaySwitch = true
        this.autoPlayButtonText = "停止"
        this.autoPlayIndex = this.autoPlayIndex >= this.dataList.length ? 0 : this.autoPlayIndex
        let word = this.dataList[this.autoPlayIndex++].word
        this.playSound(word)
        let that = this
        this.autoPlayTimer = setInterval(() => {
          word = that.dataList[that.autoPlayIndex++].word
          that.playSound(word)
        }, 2200)
        this.autoTimePlayTimer = setTimeout(
          () => {
            this.autoPlaySwitch = true
            this.autoPlay()
          },
          2200 * (that.dataList.length - that.autoPlayIndex + 0.8)
        )
      }
    },

    doSubmit() {
      const that = this
      this.countSelectNum()
      if (this.yesNum + this.notNum == 0) {
        this.alert("请选择单词")
        return
      }
      if (this.btnloading) {
        return false
      }

      this.btnloading = true
      clearInterval(this.autoPlayTimer)

      const param = { studentId: this.studentId }

      let url = null
      //如果用户就是自己，则判断为陪练自己在体验教学流程
      if (this.studentId == this.userinfo.userId) {
        url = "/vocabulary/beginTrailClass"
      } else {
        url = "/vocabulary/beginReviewClass"
        const appointment = this.store.getAppointment()
        param.aptmId = appointment.aptmId
        param.courseId = appointment.courseId
        param.courseName = appointment.courseName
      }

      const selectedItem1 = []
      const selectedItem2 = []

      if (this.dataList && this.dataList.length > 0) {
        // 打勾的单词mastery=8，打叉的mastery=1
        //此处找出所有被打了X标记的单词
        this.dataList.forEach((item) => {
          if (item.selected > 0) {
            let obj = {
              id: item.id,
              vocabularyId: item.vocabularyId,
              studentId: this.studentId,
              courseId: item.courseId,
              mastery: item.mastery,
              selected: item.selected,
              word: item.word,
              paraphrase: item.paraphrase,
              pronunciation: item.pronunciation,
            }

            //只要打了标记的单词，都提交到后台
            selectedItem1.push(obj)

            if (item.selected == 2) {
              selectedItem2.push(obj)
            }
          }
        })
      }

      //向后台提交所有做了标记的单词
      param.list = selectedItem1

      this.ajax
        .post(url, param)
        .then((res) => {
          if (res.data.success) {
            //本地只存打了叉，不会的单词
            param.list = selectedItem2
            if (that.notNum > 0) {
              if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
                this.openSign()
              } else {
                this.createForget().then(() => {
                  this.openSign()
                })
              }
            } else {
              modalController.dismiss({ status: "REVIEW" })
            }
          }
        })
        .finally(() => {
          setTimeout(() => {
            that.btnloading = false
            clearTimeout()
          }, 500)
        })
    },
    async createForget() {
      const appointment = this.store.getAppointment()
      const params = {
        aptmId: appointment.aptmId,
        startTime: appointment.beginTime,
      }
      return this.ajax.post("/forget/generateForget", params)
    },
    onClickYes(item) {
      this.tools.onClickYes(item)
      this.countSelectNum()

      item.showParaphrase = item.selected === 1 ? 2 : 0
    },

    onClickNot(item) {
      if (item.selected != 2) {
        if (this.notNum >= 45) {
          this.alert("不能再选啦~~")
          return
        }
      }

      this.tools.onClickNot(item)

      this.countSelectNum()

      item.showParaphrase = item.selected === 2 ? 2 : 0
    },

    queryMyWords(ev) {
      const appointment = this.store.getAppointment()
      let courseId = undefined
      if (appointment != null) {
        courseId = appointment.courseId
      }

      return this.ajax
        .post("/vocabulary/queryMyWords", {
          studentId: this.studentId,
          courseId: courseId,
          mastery: this.mastery,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.data.success) {
            this.courseName = res.data.courseName
            this.courseId = res.data.courseId
            const page = res.data.page
            this.totalNum = page.total
            const list = page && page.list ? page.list : []
            for (let i = 0; i < list.length; i++) {
              list[i].selected = 0
              list[i].yesColor = "gainsboro"
              list[i].notColor = "gainsboro"
              list[i].showParaphrase = 0
              this.dataList.push(list[i])
            }
            // 已加载数量达到总数则关闭无限滚动
            if (this.dataList.length >= page.total) {
              this.isDisabled = true
            }
          }
          if (ev) {
            ev.target.complete()
          }
          this.currentPage++
        })
    },

    loadData() {
      if (this.isDisabled || this.loading) return
      this.loading = true
      this.queryMyWords().finally(() => {
        this.loading = false
      })
    },

    scrollEvent(e) {
      const el = e.target
      if (this.isDisabled || this.loading) return
      // 滚动到接近底部时加载下一页
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
        this.loadData()
      }
    },

    onCloseSelf() {
      clearInterval(this.autoPlayTimer)
      modalController.dismiss()
    },
  },
}
</script>
<style scoped lang="less">
@import "@/assets/common.less";

.review {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 0 5vh;
  z-index: 1;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: 100%;
    background: #ffffff;
    border-radius: 0.5rem;

    .statistic {
      color: var(--font-grey-color);
      height: 2rem;
      line-height: 2rem;
      padding-left: 1rem;
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888; /* 滚动条的颜色 */
    border-radius: 10px; /* 滚动条的角度样式 */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* 鼠标悬停时的颜色 */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动条轨道的颜色，可以理解为背景 */
    border-radius: 10px; /* 滚动条轨道的圆角 */
  }

  &_page {
    width: 100%;
    height: calc(100vh - 9rem);
    overflow-y: scroll;
    overflow-x: hidden;

    .word-list {
      &_item {
        padding: 4vw 3vw;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          display: flex;
          font-size: var(--font-size);
          word-break: break-all;
          align-items: center;
        }

        .choose-icon {
          width: 27%;
          flex-shrink: 0;
        }
      }

      .item-checked {
        border: 1px solid var(--theme-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .translate-middle {
        margin: 0 2vw;
      }

      .test-icon {
        width: 1.8rem;
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;
    box-sizing: border-box;

    &-content {
      flex-shrink: 0;
      height: 100%;
      padding: 0 3vw;
    }
  }
}
</style>
